import HttpRequestor, { fetcher } from './httpRequestor';

class NextApiService {
  constructor(public fetch: HttpRequestor) {}
}

const api = (cookies?: string) => new NextApiService(fetcher(cookies)).fetch;

export default api;
